<template>
  <span style="color: #02A7F0;" :class="{ 'timeout': timeout }">{{ newValue }}</span>
</template>
<script>
export default {
  props: {
    value: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      newValue: "",
      interval: null,
      timeout: false,
    }
  },
  mounted() {
    this.interval = setInterval(() => {
      this.timeout = false;
      var now = new Date().getTime();
      var timeRemaining = new Date(this.value) - now;

      if (timeRemaining <= 0) {
        this.newValue = "超时";
        this.timeout = true;
        // 倒计时结束，可以执行其他操作
        clearInterval(this.interval);
      } else {
        var days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
        var hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

        function fillZero(val) {
          return val >= 10 ? val : "0" + val
        }

        let value = "";
        if (days > 0) value += `${days}天`;
        if (hours > 0) value += `${fillZero(hours)}小时`;
        if (minutes > 0) value += `${fillZero(minutes)}分钟`;
        value += `${fillZero(seconds)}秒`;

        this.newValue = value + "后 将超时揽收";
      }
    }, 1000);
  },
}
</script>
<style lang="scss" scoped>
.timeout {
  color: #F56C6C !important;
}
</style>